export const toggleResetPassModal = isOpen => dispatch => {
  dispatch({
    type: 'TOGGLE_RESET_PASS_MODAL',
    isOpen,
  });
};
